export type Id = string | number

// Kanban Types
export type Column = {
  id: Id
  title: string
}

// Enumerations
export enum Subscription {
  Monthly = 'monthly',
  Free = 'free',
  Unpaid = 'unpaid',
  Canceled = 'canceled',
}

export enum Status {
  Inactive = 'inactive',
  Suspended = 'suspended',
  Active = 'active',
  Pending = 'pending',
  Blocked = 'blocked',
}

export enum Priority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
  Late = 'late',
}

export enum Platform {
  Bing = 'bing',
  DV360 = 'dv360',
  Google = 'google',
  Meta = 'meta',
  Snap = 'snapchat',
  Taboola = 'taboola',
  Tiktok = 'tiktok',
  Zemanta = 'zemanta',
}

export enum Role {
  Admin = 'Admin',
  Manager = 'Manager',
  Associate = 'Associate',
  Advisor = 'Advisor',
  Accounting = 'Accounting',
  User = 'User',
}

export enum Progress {
  Archived = 'archived',
  New = 'new',
  Unassigned = 'unassigned',
  InProgress = 'inprogress',
  Done = 'done',
  OnHold = 'onhold',
  Canceled = 'canceled',
}

// My Types
export interface Account {
  id: Id
  client?: Client
  email: string
  username: string
  password: string
  website: string
  phone: string
  status: Status
  country: string
  proxy: string
  commission: number
  sharedon: string
  note: string
  platform: Platform
  apikey: string
  type: 'account'
}

export interface Client {
  id: Id
  name: string
  phone: string
  email: string
  website: string
  status: Status
  contract?: string
  subscription: Subscription
  subs_date: string
  ice: string
  balance: number
  bank_fee: number
  manager?: User
  type: 'client'
}

export interface Task {
  id: Id
  task_id: string
  title: string
  priority: Priority
  tags?: string[]
  desc: string
  file?: File
  fileURL?: string
  duedate: string
  progress: Progress
  taskable?: { id: Id; name: string; type: string }
  assignable?: { id: Id; name: string; type: string }
  status?: Status
  type: 'task'
}

export interface User {
  id: Id
  firstname: string
  lastname: string
  email: string
  roles: Role[]
  status: Status
  client?: Client
  create_at?: string
  type: 'user'
}

export interface Topup {
  id: Id
  amount: number
  bankFee : number
  commission : number
  reference: string
  date: string
  proof : string
  type : 'crypto' | 'bank' | 'payoneer' | 'balance'
  status : 'pending' | 'confirmed' | 'canceled' | 'wired'
  client: Client
  account ?: Account
}
